import type { HelpFile } from '../../types/help'
import { ApprovalChainTestIds } from '../../../testids/ApprovalChainTestIds'

export const approvalChainHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalChainTestIds.approverConnectorIntermediate]: null,
    [ApprovalChainTestIds.approverConnectorLast]: null,
    [ApprovalChainTestIds.btnApprove]: 'Approve this step and advance the request to the next approver.',
    [ApprovalChainTestIds.btnReject]: 'Reject the request — further approvals stop and the requester is notified.',
  },
}
